<div *ngIf="headlessMode" class="container-fluid">
	<router-outlet></router-outlet>
</div>
<nz-layout class="app-layout" *ngIf="!headlessMode">
	<nz-sider class="menu-sidebar" nzCollapsible nzWidth="256px" nzBreakpoint="md" [(nzCollapsed)]="isCollapsed"
		[nzTrigger]="null">
		<div class="sidebar-logo">
			<a href="/">
				<img *ngIf="!isCollapsed" src="assets/images/PandaHorizontalLogo.575d1c28.png"
					style="height: 3em;" />
				<img *ngIf="isCollapsed" src="assets/images/PandaHorizontalLogo.575d1c28.png"
					style="height: 3.6em;" />
			</a>
		</div>
		<div class="side-menu">
			<ul nz-menu nzTheme="dark" nzMode="inline" [nzInlineCollapsed]="isCollapsed">
				<a nz-menu-item nzMatchRouter routerLink="/analytics-landing-page">
					<fa-icon [icon]="faHome" class="me-2"></fa-icon>
					<span *ngIf="!isCollapsed">Home</span>
				</a>
				<li nz-submenu nzTitle="Member Records" nzIcon="usergroup-add"
					*hasPermission="['MemberAdd','MembersBulkImport','MemberSearch']">
					<ul>
						<a nz-menu-item nzMatchRouter routerLink="/member/new"
							*hasPermission="['MemberAdd']">
							Add Member
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/member/bulk/list"
							*hasPermission="['MembersBulkImport']">
							Bulk Upload
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/member/list"
							*hasPermission="['MemberSearch']">
							Search Member
						</a>
					</ul>
				</li>
				<ng-container *ngIf="showWorkflowSectionClaims">
					<li nz-submenu nzTitle="Claims" nzIcon="retweet"
						*hasPermission="['Ticket','TicketAdmin']">
						<ul>
							<a nz-menu-item nzMatchRouter
								routerLink="/ticket/Claim/member-search"
								*hasPermission="['Ticket','TicketAdmin']">
								New Claim
							</a>
							<a nz-menu-item nzMatchRouter routerLink="/ticket/Claim/list"
								*hasPermission="['Ticket','TicketAdmin']">
								My Claims
							</a>
							<a nz-menu-item nzMatchRouter
								routerLink="/ticket/Claim/dashboard"
								*hasPermission="['Ticket','TicketAdmin']">
								Claims workflows
							</a>
							<li nz-menu-item *ngIf="!isCollapsed">
								<input nz-input [(ngModel)]="ticketClaimSearchPhrase"
									(keyup.enter)="onTicketSearch('Claim',ticketClaimSearchPhrase)"
									placeholder="Search tickets..."
									style="width: 100%;" />
							</li>
						</ul>
					</li>
				</ng-container>
				<ng-container *ngIf="showWorkflowSectionComplaints">
					<li nz-submenu nzTitle="Complaints" nzIcon="file-exclamation"
						*hasPermission="['Ticket','TicketAdmin']">
						<ul>
							<a nz-menu-item nzMatchRouter
								routerLink="/ticket/Complaint/member-search"
								*hasPermission="['Ticket','TicketAdmin']">
								New Complaint
							</a>
							<a nz-menu-item nzMatchRouter
								routerLink="/ticket/Complaint/list"
								*hasPermission="['Ticket','TicketAdmin']">
								My Complaints
							</a>
							<a nz-menu-item nzMatchRouter
								routerLink="/ticket/Complaint/dashboard"
								*hasPermission="['Ticket','TicketAdmin']">
								Complaints workflows
							</a>
							<li nz-menu-item *ngIf="!isCollapsed">
								<input nz-input
									[(ngModel)]="ticketComplaintSearchPhrase"
									(keyup.enter)="onTicketSearch('Complaint',ticketComplaintSearchPhrase)"
									placeholder="Search tickets..."
									style="width: 100%;" />
							</li>
						</ul>
					</li>
				</ng-container>
				<ng-container *ngIf="showWorkflowSectionCases">
					<li nz-submenu nzTitle="Cases" nzIcon="file-exclamation"
						*hasPermission="['Ticket','TicketAdmin']">
						<ul>
							<a nz-menu-item nzMatchRouter
								routerLink="/ticket/Case/member-search"
								*hasPermission="['Ticket','TicketAdmin']">
								New Case
							</a>
							<a nz-menu-item nzMatchRouter routerLink="/ticket/Case/list"
								*hasPermission="['Ticket','TicketAdmin']">
								My Cases
							</a>
							<a nz-menu-item nzMatchRouter
								routerLink="/ticket/Case/dashboard"
								*hasPermission="['Ticket','TicketAdmin']">
								Case workflows
							</a>
							<li nz-menu-item *ngIf="!isCollapsed">
								<input nz-input [(ngModel)]="ticketCaseSearchPhrase"
									(keyup.enter)="onTicketSearch('Case', ticketCaseSearchPhrase)"
									placeholder="Search tickets..."
									style="width: 100%;" />
							</li>
						</ul>
					</li>
				</ng-container>
				<li nz-submenu nzTitle="Reporting" nzIcon="bar-chart"
					*hasPermission="['TicketReportList', 'TicketAdmin']">
					<ul>
						<a nz-menu-item nzMatchRouter routerLink="/ticket/report/list">
							Case Reports
						</a>
					</ul>
				</li>
				<a nz-menu-item nzMatchRouter routerLink="/analytics-list">
					<fa-icon [icon]="faAnalytics" class="me-2"></fa-icon>
					<span *ngIf="!isCollapsed">Analytics</span>
				</a>
				<li nz-submenu nzTitle="Communication" nzIcon="mail"
					*hasPermission="['CommunicationSend','CommunicationScheduledAutomated', 'CommunicationLog']">
					<ul>
						<a nz-menu-item nzMatchRouter routerLink="/communication/send"
							*hasPermission="['CommunicationSend']">
							Send Communication
						</a>
						<a nz-menu-item nzMatchRouter
							routerLink="/communication/scheduled-automated"
							*hasPermission="['CommunicationScheduledAutomated']">
							Scheduled & Automated
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/communication/log"
							*hasPermission="['CommunicationLog']">
							Communication Log
						</a>
					</ul>
				</li>
				<li nz-submenu nzTitle="Entity" nzIcon="appstore-add"
					*hasPermission="['AgentList', 'AgentAdd', 'EntityList', 'EntityAdd']">
					<ul>
						<a nz-menu-item nzMatchRouter routerLink="/agent/admin/list"
							*hasPermission="['AgentList','AgentAdd']">
							Agent Admin
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/agent/fao/list"
							*hasPermission="['AgentList','AgentAdd']">
							Agent FAO
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/agent/underwriter/list"
							*hasPermission="['AgentList','AgentAdd']">
							Agent Underwriters
						</a>

						<a nz-menu-item nzMatchRouter routerLink="/category/list"
							*hasPermission="['EntityList','EntityAdd']">
							Categories
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/employer/list"
							*hasPermission="['EntityList','EntityAdd']">
							Employers
						</a>
						<ng-container *ngIf="enableProductAndPolicy">
							<a nz-menu-item nzMatchRouter routerLink="/bank/list"
								*hasPermission="['EntityList','EntityAdd']">
								Bank
							</a>
							<a nz-menu-item nzMatchRouter
								[routerLink]="['/dynamic','binder','list']">
								Binder
							</a>
							<a nz-menu-item nzMatchRouter
								[routerLink]="['/dynamic','policy_group','list']">
								Policy Group
							</a>
							<a nz-menu-item nzMatchRouter
								[routerLink]="['/dynamic','intermediary_administrator','list']">
								Intermediate Administration
							</a>
							<a nz-menu-item nzMatchRouter
								[routerLink]="['/dynamic','intermediary_group','list']">
								Intermediate Group
							</a>
							<a nz-menu-item nzMatchRouter
								[routerLink]="['/dynamic','underwriter','list']">
								Underwriter
							</a>
						</ng-container>
						<a nz-menu-item nzMatchRouter
							[routerLink]="['/dynamic','service_provider','list']">
							Service Provider
						</a>
					</ul>
				</li>

				<a nz-menu-item nzMatchRouter routerLink="/ticket/invoice/approval/list">
					<fa-icon [icon]="faAnalytics" class="me-2"></fa-icon>
					Invoice Approval
				</a>
				<a nz-menu-item nzMatchRouter routerLink="/ticket/invoice/list">
					<fa-icon [icon]="faAnalytics" class="me-2"></fa-icon>
					Invoice View
				</a>
				<ng-container *ngIf="enableProductAndPolicy">
					<a nz-menu-item nzMatchRouter routerLink="/product/list"
						*hasPermission="['ProductView']">
						<fa-icon [icon]="faAnalytics" class="me-2"></fa-icon>
						Products
					</a>
					<li nz-submenu nzTitle="Policy Servicing" nzIcon="appstore-add"
						*hasPermission="['PolicyView','PolicyCreate','PolicyUpdate','PolicySearch']">
						<ul>
							<ng-container *hasPermission="['PolicySearch']">
								<li nz-menu-item *ngIf="!isCollapsed">
									<input nz-input [(ngModel)]="policySearchPhrase"
										(keyup.enter)="onPolicySearch(policySearchPhrase)"
										placeholder="Search policy..."
										style="width: 100%;" />
								</li>
							</ng-container>
							<a nz-menu-item nzMatchRouter routerLink="policy/new"
								*hasPermission="['PolicyCreate']">
								New Policy
							</a>
						</ul>
					</li>
					<ng-container
						*hasPermission="['ProductScheduleView','ProductScheduleUpload','ProductDepositView','PolicyBenefitPaymentApprovalViewPendingPayments','PolicyBenefitPaymentApprovalApprovePayments']">
						<li nz-submenu nzTitle="Finance" nzIcon="appstore-add"
							*ngIf="enableProductAndPolicy">
							<ul>
								<a nz-menu-item nzMatchRouter routerLink="/finance/home"
									*hasPermission="['ProductScheduleView','ProductScheduleUpload','ProductDepositView']">
									Finance Home
								</a>
								<a nz-menu-item nzMatchRouter
									routerLink="benefit-payment/approval/list"
									*hasPermission="['PolicyBenefitPaymentApprovalViewPendingPayments','PolicyBenefitPaymentApprovalApprovePayments']">
									Payment Approval List
								</a>
								<a nz-menu-item nzMatchRouter
									routerLink="benefit-payment/list"
									*hasPermission="['PolicyBenefitPaymentApprovalViewPendingPayments','PolicyBenefitPaymentApprovalApprovePayments']">
									Bank Payment
								</a>
							</ul>
						</li>
					</ng-container>
				</ng-container>


				<li nz-submenu nzTitle="Configuration" nzIcon="setting"
					*hasPermission="['DynamicPropertyView', 'WorkflowView','WorkflowAdd','RoleList','PermissionManage','WorkflowManageRoles']">
					<ul>
						<a nz-menu-item nzMatchRouter routerLink="/dynamic/list"
							*hasPermission="['DynamicPropertyView']">
							Dynamic Properties
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/form/list">
							Forms
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/workflow/list"
							*hasPermission="['WorkflowView','WorkflowAdd']">
							Workflows
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/workflow_role/list"
							*hasPermission="['WorkflowManageRoles']">
							Ticket Roles
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/role/list"
							*hasPermission="['RoleList']">
							App Roles
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/permissions"
							*hasPermission="['PermissionManage']">
							App Permissions
						</a>
						<a nz-menu-item nzMatchRouter
							routerLink="/benefit-payment/approval/setting"
							*ngIf="enableProductAndPolicy">
							Policy Approval Setting
						</a>

						<a nz-menu-item nzMatchRouter routerLink="/dashboard">
							Dashboard
						</a>
						<a nz-menu-item nzMatchRouter routerLink="/dashboard/list">
							Dashboard List
						</a>
						<a nz-menu-item nzMatchRouter
							routerLink="/ticket/invoice/approval/setting">
							<fa-icon [icon]="faAnalytics" class="me-2"></fa-icon>
							Invoice Approval Setting
						</a>
					</ul>
				</li>
				<!-- <li class="ant-menu-item no-highlight-item mt-3" *ngIf="!isCollapsed">
					<nz-select [(ngModel)]="theme" (ngModelChange)="onThemeChange($event)" style="width: 100%;">
						<nz-option nzValue="default" nzLabel="Default"></nz-option>
						<nz-option nzValue="compact" nzLabel="Compact"></nz-option>
					</nz-select>
				</li> -->
			</ul>
		</div>
	</nz-sider>
	<nz-layout class="content-layout">
		<nz-header>
			<div class="app-header">
				<span class="header-trigger" (click)="isCollapsed = !isCollapsed">
					<span class="trigger" nz-icon
						[nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
				</span>
				<app-hierarchy-input *ngIf="hierarchy"
					(onChange)="changeHierarchy($event)"></app-hierarchy-input>
				<div class="float-end me-3">
					<div ngbDropdown>
						<div ngbDropdownToggle class="align-items-center btn btn-sm me-2"
							id="profileDropdown">
							<span class="me-2">{{username}}</span>
							<img src="https://w7.pngwing.com/pngs/751/863/png-transparent-user-customer-account-customers-person-filled-profile-ios-tab-bar-icon-thumbnail.png"
								alt="User" class="rounded-circle" width="32"
								height="32" />
						</div>
						<div ngbDropdownMenu aria-labelledby="profileDropdown">
							<a class="dropdown-item"
								[routerLink]="['/agent','self']">Profile</a>
							<div class="dropdown-divider"></div>
							<button class="dropdown-item" (click)="logout()">Logout</button>
						</div>
					</div>
				</div>
			</div>
		</nz-header>
		<nz-content>
			<div class="inner-content">
				<router-outlet *ngIf="hierarchy"></router-outlet>
				<app-force-password-change></app-force-password-change>
				<ng-container *ngIf="showPoh">
					<div class="fixed-widgets" *ngIf="chatVisible == false">
						<nz-float-button [nzIcon]="icon" nzType="primary" (click)="openChat()">
							<ng-template #icon>
								<img src="assets/images/Panda%20-%20Icon%20(Dark%20Background).png"
									alt="Panda" style="width: 20px; height: 20px" />
							</ng-template>
						</nz-float-button>
					</div>

					<nz-drawer [nzVisible]="chatVisible" nzPlacement="right"
						nzTitle="POH AI Assistant" (nzOnClose)="chatVisible = false"
						[nzWidth]="600" nzWrapClassName="poh">
						<app-ai-chat-widget *nzDrawerContent>

						</app-ai-chat-widget>
					</nz-drawer>
				</ng-container>
			</div>
		</nz-content>
	</nz-layout>
</nz-layout>